import React from 'react';
import { Box, Container, Typography, Paper, Grid, Card, CardActionArea, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

// アイコン
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ScienceIcon from '@mui/icons-material/Science';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

const DataRegistration = () => {
  const navigate = useNavigate();

  // 各種登録機能
  const registrationOptions = [
    {
      title: "顧客登録",
      description: "新規顧客の情報を登録します",
      icon: <PersonAddIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      onClick: () => {
        sessionStorage.setItem("fromDashboard", "true");
        sessionStorage.removeItem("clientData");
        navigate("/client-registration-step1");
      },
      color: "rgba(255, 152, 0, 0.1)"
    },
    {
      title: "製品管理",
      description: "製品の登録・編集・一覧",
      icon: <ScienceIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      onClick: () => navigate("/product-registration"),
      color: "rgba(255, 152, 0, 0.1)"
    },
    {
      title: "顧客一括登録(CSV)",
      description: "CSVファイルから複数顧客を一括登録",
      icon: <CloudUploadIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      onClick: () => navigate("/client-csv-upload"),
      color: "rgba(255, 152, 0, 0.1)"
    },

  ];

  return (
    <Box sx={{ bgcolor: '#F5F7FA', minHeight: '100vh' }}>
      <Header />

      <Container 
        maxWidth="md" 
        sx={{ 
          mt: 4,
          // PWAボトムナビゲーション対応：安全マージンを確保
          pb: { xs: 12, sm: 6 }, // モバイルは12（約96px）、デスクトップは6
          // 最小高さを確保してスクロール可能にする
          minHeight: { xs: 'calc(100vh - 200px)', sm: 'auto' },
          px: { xs: 2, sm: 3 }
        }}
      >
        {/* ページタイトル */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 4,
            borderRadius: 2,
            background: 'linear-gradient(to right, #ff9800, #ff7b00)',
            color: 'white'
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
              データ登録
            </Typography>
            <Typography variant="subtitle1">
              登録する項目を選択してください
            </Typography>
          </Box>
        </Paper>

        {/* 戻るボタン */}
        <Box sx={{ mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/dashboard')}
            sx={{ 
              color: 'text.secondary',
              minHeight: { xs: 48, sm: 40 } // タッチしやすい高さ
            }}
          >
            ダッシュボードに戻る
          </Button>
        </Box>

        {/* 登録オプション */}
        <Grid container spacing={3}>
          {registrationOptions.map((option, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card
                elevation={2}
                sx={{
                  height: '100%',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6
                  }
                }}
              >
                <CardActionArea
                  onClick={option.onClick}
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 4,
                    minHeight: { xs: 200, sm: 160 } // タッチしやすいサイズ
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: option.color,
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      mb: 3
                    }}
                  >
                    {option.icon}
                  </Box>
                  <Typography variant="h5" component="h2" sx={{ fontWeight: 500, textAlign: 'center', mb: 2 }}>
                    {option.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center' }}>
                    {option.description}
                  </Typography>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default DataRegistration;